import { render } from "./PetFormModal.vue?vue&type=template&id=0a8892ce&scoped=true&ts=true"
import script from "./PetFormModal.vue?vue&type=script&lang=ts"
export * from "./PetFormModal.vue?vue&type=script&lang=ts"

import "./PetFormModal.vue?vue&type=style&index=0&id=0a8892ce&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a8892ce"]])

export default __exports__